import { useQuery, useManualQuery } from "graphql-hooks";

const USER_PRICE_CALCULATOR_QUERY = `
query GetMlUserPriceCalculator($price: Float!, $weight: String!) {
  getMlUserPriceCalculator(price: $price, weight: $weight)
}
`

export const useUserPriceCalculatorManual = () => {
    const [getUserPriceCalculator, { data, loading, error }] = useManualQuery(USER_PRICE_CALCULATOR_QUERY);
    return { data, loading, error, getUserPriceCalculator };
}
